var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.drawer,
            size: "80%",
            wrapperClosable: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "header" },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "300px" },
                  attrs: { placeholder: "请选择模板" },
                  on: { change: _vm.changeTemplate },
                  model: {
                    value: _vm.TemplateId,
                    callback: function ($$v) {
                      _vm.TemplateId = $$v
                    },
                    expression: "TemplateId",
                  },
                },
                _vm._l(_vm.TemplateList, function (item) {
                  return _c("el-option", {
                    key: item.Id,
                    attrs: { label: item.Name, value: item.Id },
                  })
                }),
                1
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.generatePdf },
                },
                [_vm._v("生成文件")]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "14px",
                    color: "red",
                    "margin-left": "10px",
                  },
                },
                [_vm._v("注：设备卡片打印需使用专用打印机打印")]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "form-center",
            },
            [
              _vm.TemplateId
                ? _c(
                    "div",
                    { ref: "Content" },
                    _vm._l(_vm.rows, function (ele) {
                      return _c(
                        "div",
                        {
                          key: ele.Id,
                          staticClass: "Dom",
                          style: `width:${_vm.TemplateJson.width}cm;height:${_vm.TemplateJson.height}cm;position: relative;`,
                        },
                        [
                          _c(
                            "div",
                            {
                              ref: "pdfContent",
                              refInFor: true,
                              style: `width:${_vm.TemplateJson.width}cm;height:${_vm.TemplateJson.height}cm;position: relative;`,
                            },
                            _vm._l(
                              _vm.TemplateJson.printlist,
                              function (item, index) {
                                return _c(
                                  "VueDragResize",
                                  {
                                    key: item.Id,
                                    attrs: {
                                      gridX: 2,
                                      gridY: 2,
                                      isActive: false,
                                      preventActiveBehavior: false,
                                      isDraggable: false,
                                      isResizable: false,
                                      aspectRatio: false,
                                      parentLimitation: "",
                                      w: item.w,
                                      h: item.h,
                                      x: item.x,
                                      y: item.y,
                                      minh: 28,
                                      minw: 80,
                                    },
                                  },
                                  [
                                    item.FiledKey != "Id"
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "100%",
                                              height: "100%",
                                              display: "flex",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                style: `font-size:${item.title_fontSize}px;font-weight:${item.title_bold};line-height:${item.title_lineHeight}px;text-align:${item.title_align};font-family:${item.title_family};;`,
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(item.FieldName) +
                                                    "： "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                style: `${
                                                  item.isline
                                                    ? "border-bottom: 1px solid #000;"
                                                    : ""
                                                }flex: 1;font-size:${
                                                  item.fontSize
                                                }px;font-weight:${
                                                  item.bold
                                                };line-height:${
                                                  item.lineHeight
                                                }px;text-align:${
                                                  item.align
                                                };font-family:${item.family};`,
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(ele[item.FiledKey]) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _c("vue-qr", {
                                          attrs: {
                                            size: item.w,
                                            text: ele[item.FiledKey],
                                            margin: 0,
                                          },
                                        }),
                                  ],
                                  1
                                )
                              }
                            ),
                            1
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }